var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import ContactModal from '@/common/components/Modal/index.vue';
var CustomerService = /** @class */ (function (_super) {
    __extends(CustomerService, _super);
    function CustomerService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isShowCode = false;
        return _this;
    }
    Object.defineProperty(CustomerService.prototype, "user", {
        get: function () {
            return this.$store.getters['getUserInfo'];
        },
        enumerable: false,
        configurable: true
    });
    CustomerService.prototype.mounted = function () {
        var _this = this;
        window.$_EventLib.on('clickContact', function () {
            _this.showCode();
        });
    };
    CustomerService.prototype.showCode = function () {
        this.isShowCode = true;
        // 数据埋点
        window.LHBbigdata.send({
            event_id: '380691eb-0def-4d48-92f8-202883546624',
            msg: {
                operation: '联系客服',
                enterprise_id: this.user.companyName,
                user_name: this.user.name,
                user_tel: this.user.mobile,
            },
        });
    };
    CustomerService = __decorate([
        Component({
            components: {
                ContactModal: ContactModal
            }
        })
    ], CustomerService);
    return CustomerService;
}(Vue));
export default CustomerService;
